import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { AppData } from "../../types";
import { getAppById } from "../../resources/apps";
import { AppPageTabsStore } from "./AppPageTabsStore";
import { BackButton } from "../../components/BackButton/BackButton";

export const AppPage = () => {
  const [appData, setAppData] = useState<AppData | null>(null);
  const { appId } = useParams();

  useEffect(() => {
    async function getData() {
      try {
        if (typeof appId !== "string") {
          console.error('Error: URL parameter "appId" is not a string.');
          return;
        }

        const app = await getAppById(appId);
        setAppData(app);
      } catch (error) {
        console.error("getAppData: ", error);
      }
    }

    void getData();
  }, [appId]);

  return appData !== null ? (
    <div className="app-page">
      <div className="app-page__intro-container">
        <BackButton />
        <h1 className="app-page__header">{appData.name}</h1>
        <NavLink className={"app-page__how-to-install"} to={"/how-to-install"}>
          How to install ⟶
        </NavLink>
      </div>
      <AppPageTabsStore />
    </div>
  ) : (
    <></>
  );
};
